const userModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  templateUrl: '/modules/users/account-list/user-modal/user-modal.html',
  controller: 'UserModalController',
};

angular
  .module('users.module')
  .component('userModal', userModal);
